import { createIcon } from '@chakra-ui/icons';

export const Google = createIcon({
  displayName: 'Google',
  viewBox: '0 0 24 24',
  path: [
    <svg fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M23.3418 12.2667C23.3418 11.28 23.2623 10.56 23.0904 9.81335H11.9091V14.2666H18.4722C18.34 15.3733 17.6254 17.04 16.0375 18.16L16.0153 18.309L19.5506 21.0687L19.7955 21.0934C22.045 19 23.3418 15.92 23.3418 12.2667Z"
        fill="#4285F4"
      />
      <path
        d="M11.9091 24C15.1245 24 17.8239 22.9332 19.7955 21.0933L16.0375 18.1599C15.0319 18.8666 13.6822 19.3599 11.9091 19.3599C8.75981 19.3599 6.0869 17.2666 5.13408 14.3733L4.99442 14.3852L1.31834 17.2519L1.27026 17.3866C3.22863 21.3065 7.25127 24 11.9091 24Z"
        fill="#34A853"
      />
      <path
        d="M5.13409 14.3734C4.88268 13.6267 4.73719 12.8266 4.73719 12C4.73719 11.1733 4.88269 10.3733 5.12087 9.62668L5.11421 9.46766L1.39206 6.55493L1.27027 6.6133C0.463137 8.23999 0 10.0667 0 12C0 13.9334 0.463137 15.76 1.27027 17.3867L5.13409 14.3734Z"
        fill="#FBBC05"
      />
      <path
        d="M11.9091 4.63997C14.1453 4.63997 15.6538 5.6133 16.5139 6.42669L19.8749 3.12C17.8107 1.18667 15.1245 0 11.9091 0C7.25127 0 3.22863 2.69331 1.27026 6.61329L5.12086 9.62666C6.0869 6.73333 8.75981 4.63997 11.9091 4.63997Z"
        fill="#EB4335"
      />
    </svg>,
  ],
});
